"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _react = _interopRequireDefault(require("react"));

var _reactFeather = require("react-feather");

var _pdf = _interopRequireDefault(require("../../assets/images/file/pdf.svg"));

var _xml = _interopRequireDefault(require("../../assets/images/file/xml.svg"));

var _html = _interopRequireDefault(require("../../assets/images/file/html.svg"));

var hasWords = function hasWords(verifiedWord, wordList) {
  var _iterator = (0, _createForOfIteratorHelper2.default)(wordList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var word = _step.value;

      if (verifiedWord.toLowerCase().includes(word)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};

var Icon = function Icon(_ref) {
  var title = _ref.title;

  switch (true) {
    case hasWords(title, ['summary']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.BookOpen, {
        size: 15
      });

    case hasWords(title, ['payers', 'insurance']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.DollarSign, {
        size: 15
      });

    case hasWords(title, ['directive', 'file', 'attach', 'document']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.File, {
        size: 15
      });

    case hasWords(title, ['function']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Activity, {
        size: 15
      });

    case hasWords(title, ['categor', 'hierar', 'section']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Copy, {
        size: 15
      });

    case hasWords(title, ['problem']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.AlertCircle, {
        size: 15
      });

    case hasWords(title, ['family', 'social', 'organization']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Users, {
        size: 15
      });

    case hasWords(title, ['alert', 'allergy', 'allergie']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.AlertTriangle, {
        size: 15
      });

    case hasWords(title, ['medic', 'immun']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Shield, {
        size: 15
      });

    case hasWords(title, ['vital']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Heart, {
        size: 15
      });

    case hasWords(title, ['result']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.FileText, {
        size: 15
      });

    case hasWords(title, ['procedure']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.GitBranch, {
        size: 15
      });

    case hasWords(title, ['encounter', 'labor']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Search, {
        size: 15
      });

    case hasWords(title, ['plan']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Book, {
        size: 15
      });

    case hasWords(title, ['patient']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.User, {
        size: 15
      });

    case hasWords(title, ['date']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Calendar, {
        size: 15
      });

    case hasWords(title, ['signed']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Clipboard, {
        size: 15
      });

    case hasWords(title, ['contact']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Mail, {
        size: 15
      });

    case hasWords(title, ['sex']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Compass, {
        size: 15
      });

    case hasWords(title, ['author']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Edit, {
        size: 15
      });

    case hasWords(title, ['authenticator', 'performer']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.CheckCircle, {
        size: 15
      });

    case hasWords(title, ['created at', 'time']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Clock, {
        size: 15
      });

    case hasWords(title, ['list']):
      return /*#__PURE__*/_react.default.createElement(_reactFeather.List, {
        size: 15
      });

    case hasWords(title, ['application/pdf']):
      return /*#__PURE__*/_react.default.createElement("img", {
        src: _pdf.default,
        alt: ""
      });

    case hasWords(title, ['text/html']):
      return /*#__PURE__*/_react.default.createElement("img", {
        src: _html.default,
        alt: ""
      });

    case hasWords(title, ['text/xml']):
      return /*#__PURE__*/_react.default.createElement("img", {
        src: _xml.default,
        alt: ""
      });

    default:
      return /*#__PURE__*/_react.default.createElement(_reactFeather.Circle, {
        size: 15
      });
  }
};

exports.Icon = Icon;